import { IOAuthCredentialDisplayStrings, OAuthCredentialsService } from '../../../connectivity/services/OAuthCredentialsService';
import { IOAuthCredentialTypeInfo } from '../../../ts/ServerApi/types/IOAuthCredential';

function filter(credentialTypeInfo: IOAuthCredentialTypeInfo) {
  const displayStrings: IOAuthCredentialDisplayStrings = OAuthCredentialsService.getDisplayStrings(credentialTypeInfo.type);
  return displayStrings && displayStrings.displayName;
}

export const CredentialTypeFilter = {
  filter
};
